import React from "react";
import tw, { styled } from "twin.macro";
import "styled-components/macro";
import _ from "lodash";
import Icon from "./Icon";

const Container = styled.div`
  ${tw`bg-white p-5`}
`;

const Header = styled.div`
  ${tw`
    uppercase my-2.5 pb-2.5
    border-b border-b-black/70
  `}
`;

const ListContainer = styled.div`
  ${tw`text-black/70`}
`;
const ListItem = styled.div`
  ${tw`flex items-start my-6`}
`;
const ItemIcon = styled.div`
  ${tw`flex items-center mr-1`}
`;
const ItemText = styled.div`
  ${tw`flex flex-col`}
`;
const ItemTextLink = styled.a`
  ${tw`block`}
`;
const MapContainer = styled.div`
  ${tw`mt-8`}
`;

const ContactWidget = ({ color, site }) => {
  return (
    <Container>
      <Header color={color} site={site}>
        Contact
      </Header>
      <ListContainer>
        <ListItem>
          <ItemIcon>
            <Icon name="mail" />
          </ItemIcon>
          {site === "dawgs" && (
            <ItemTextLink href="mailto:info@dawgsbaseball.ca">
              info@dawgsbaseball.ca
            </ItemTextLink>
          )}
          {site === "diamondbacks" && (
            <ItemTextLink href="mailto:info@calgarydiamondbacks.com">
              info@calgarydiamondbacks.com
            </ItemTextLink>
          )}
          {site === "academy" && (
            <ItemTextLink href="mailto:jircandia@icloud.com">
              jircandia@icloud.com
            </ItemTextLink>
          )}
        </ListItem>
        <ListItem>
          <ItemIcon>
            <Icon name="phone" />
          </ItemIcon>
          {site === "dawgs" && (
            <ItemTextLink href="tel:14032623294">
              {"(403)262-3294"}
            </ItemTextLink>
          )}
          {site === "diamondbacks" && (
            <ItemTextLink href="tel:14038162516">
              {"(403)816-2516"}
            </ItemTextLink>
          )}
          {site === "academy" && (
            <ItemTextLink href="tel:14039953241">
              {"(403)995-3241"}
            </ItemTextLink>
          )}
        </ListItem>
        {site === "dawgs" && (
          <ListItem>
            <ItemIcon>
              <Icon name="location_on" />
            </ItemIcon>
            <ItemText>Seaman Stadium</ItemText>
          </ListItem>
        )}
        {site === "diamondbacks" && (
          <ListItem>
            <ItemIcon>
              <Icon name="location_on" />
            </ItemIcon>
            <ItemText>Glen Hanson Field</ItemText>
          </ListItem>
        )}
        {site === "dawgs" && (
          <ListItem>
            <ItemIcon>
              <Icon name="map" />
            </ItemIcon>
            <ItemText>
              <div>Okotoks Dawgs Baseball Club</div>
              <div>PO Box 298</div>
              <div>Okotoks, AB T1S 1A5</div>
            </ItemText>
          </ListItem>
        )}
        {site === "diamondbacks" && (
          <ListItem>
            <ItemIcon>
              <Icon name="map" />
            </ItemIcon>
            <ItemText>
              <div>1401 25 Ave NE</div>
              <div>Calgary, AB T2E 7L6</div>
            </ItemText>
          </ListItem>
        )}
      </ListContainer>
      {site === "dawgs" && (
        <MapContainer>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2526.0395308797447!2d-113.95076894851196!3d50.71920577941281!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x537199d9ad1860b3%3A0x2a8c442d69a0c362!2sSeaman%20Stadium!5e0!3m2!1sen!2sca!4v1681150379618!5m2!1sen!2sca"
            height="300"
            style={{ border: 0, width: "100%" }}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </MapContainer>
      )}
      {site === "diamondbacks" && (
        <MapContainer>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d156.67595590310916!2d-114.02385256101114!3d51.07495961226565!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x53716522bc826695%3A0x587dd343d6ed08f9!2sGlen%20Hansen%20Field%20-%20Foothills%20Major%20Baseball%20Association!5e0!3m2!1sen!2sca!4v1716911713766!5m2!1sen!2sca"
            height="300"
            style={{ border: 0, width: "100%" }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </MapContainer>
      )}
    </Container>
  );
};

export default ContactWidget;
